import get from 'lodash.get';

const getDesignAutomation = (rootState) => get(rootState, 'ws.template.meta.designAutomation', {});

export default getDesignAutomation;
